
import {defineComponent} from 'vue';
import ScreenWrapper from "@/components/elements/ScreenWrapper.vue";
import {useState} from "@/hooks/state";
import {ScreenConfigOptions} from "@/Screens.types";
import ActionButton from "@/components/elements/ActionButton.vue";

const state = useState();
export default defineComponent({
  components: {
    ActionButton,
    ScreenWrapper
  },
  props: {
    msg: String,
    goTo: Function,
    config: Object as () => ScreenConfigOptions,
  },

  setup() {
    return {
      state
    }
  },
  data() {
    return {
      screen: this.config.screenId,
      showModal: false,
      showQuestion: false,
    }
  },

  computed: {
    correct() {
      return this.state.answers.value?.[this.config.answerKey] == this.config.correctAnswer
    },

    tooHighAnswer() {
      return this.state.answers.value?.[this.config.answerKey] > this.config.correctAnswer
    },

    bgImage() {
      const answer = this.state.answers.value?.[this.config.answerKey];
      const answerImage = this.config.bgAnswerImages?.[answer];

      return answerImage || this.config.bgImage;
    }
  },

  mounted() {
    // setTimeout(() => {
    // this.$root.setupAndPlayIfOn(this.FILES.audio_welcome)
    // }, 1000)
  },

  methods: {
    next() {
      this.goTo(this.config.screenNext)
    },
    back() {
      this.goTo(-1)
    },
    start() {
      // Open modal for nicname
      this.showNicknameModal = true;
    },
  }
});
